import queryString from 'query-string';

const getAssetKey = (props) =>
  props?.match?.params?.key || queryString.parse(props?.location?.search)?.key;
const getAssetCode = (props) =>
  queryString.parse(props?.location?.search)?.code;
const getAssesUrl = (state) => state?.asset?.assetUrl;
const getContactInfo = (state) => state?.asset?.contactInfo;
const getAssetErrorCode = (state) => state?.asset?.errorCode;
const getContactType = (state) => state?.asset?.contactType;
const getContactFirstName = (state) => state?.asset?.firstName;

export {
  getAssetKey,
  getAssetCode,
  getAssesUrl,
  getContactInfo,
  getAssetErrorCode,
  getContactFirstName,
  getContactType,
};
